import axios from 'axios'

import apiClient, { setTokens, clearTokens, refreshAccessToken } from './client'
import type { TokenResponse, Usuario, AuthContext } from '@/types/gia'

const API_URL = process.env.NEXT_PUBLIC_API_URL || '/api'

export const authApi = {
  // Google Login - exchange id_token for JWT
  googleLogin: async (credential: string): Promise<TokenResponse> => {
    const response = await axios.post<TokenResponse>(`${API_URL}/auth/google/`, { credential })
    const { access, refresh } = response.data

    setTokens(access, refresh)

    return response.data
  },

  // Logout - clear tokens
  logout: (): void => {
    clearTokens()
  },

  // Get current user (legacy)
  me: async (): Promise<Usuario> => {
    const response = await apiClient.get<Usuario>('/usuarios/me/')

    return response.data
  },

  // Get auth context (incluye permisos y módulos)
  context: async (options?: { centroId?: number | null }): Promise<AuthContext> => {
    const response = await apiClient.get<AuthContext>('/auth/context/', {
      params: options?.centroId ? { centro: options.centroId } : undefined
    })

    return response.data
  },

  // Refresh token
  refresh: async (): Promise<string | null> => {
    try {
      return await refreshAccessToken()
    } catch {
      clearTokens()

      return null
    }
  },

  // Verify token is valid
  verify: async (token: string): Promise<boolean> => {
    try {
      await axios.post(`${API_URL}/token/verify/`, { token })

      return true
    } catch {
      return false
    }
  }
}

export default authApi
